'use client';

import { Link } from '@tanstack/react-router';

import { useIsTattooPage } from '@/hooks/useIsTattooPage';
import { cn } from '@/lib/utils';

import Button from '../Button/Button';

type Props = {
  className?: string;
};

const Footer = ({ className = '' }: Props) => {
  const isTattooPage = useIsTattooPage();

  const bgColor = isTattooPage ? 'bg-emerald-50' : 'bg-amber-50';
  const buttonClass = isTattooPage ? 'bg-emerald-600 hover:bg-emerald-700 text-white' : '';
  const year = new Date().getFullYear();

  return (
    <footer className={cn('mt-auto', bgColor, className)}>
      <div className="mx-auto max-w-7xl overflow-hidden px-6 py-20 sm:py-24 lg:px-8">
        <div className="-mb-6 sm:flex sm:justify-center sm:space-x-12" aria-label="Footer">
          <Link to="/rendez-vous">
            <Button
              size="lg"
              className={cn('meeting-button w-full', buttonClass)}
              trackEvent="RendezVousClick"
              trackProps={{ location: 'footer' }}
            >
              Prendre rendez-vous
            </Button>
          </Link>
        </div>

        <p className="mt-10 text-center text-xs leading-5 text-gray-500">
          &copy; {year} azelysse.fr. Tous droits reservés. Fait avec ❤️ par{' '}
          <a
            href="https://twitter.com/Cl3tus_"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Cl3tus
          </a>
          .
        </p>
      </div>
    </footer>
  );
};

export default Footer;
